import { Button } from "@components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { MessageSquareIcon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";

export function EmptySearches({ orgUuid }: { orgUuid: string }) {
  return (
    <Empty className="py-4 md:py-6">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <MessageSquareIcon />
        </EmptyMedia>
        <EmptyTitle>
          <Trans>Inga bevakningar skapade</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Du har inte skapat några bevakningar än.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button asChild>
          <Link to={generatePath(ROUTES.SEARCH_ORGID, { orgUuid })}>
            <Trans>Skapa bevakning</Trans>
          </Link>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
